// T142 — pure sort helpers for the dashboard "Available jobs" table. Kept out
// of DashboardPage.jsx so they're unit-testable without mounting the page.

// The presets offered in the "Sort" menu (mobile + discoverability). The
// clickable column headers drive the same (sortKey, sortDir) state and can
// also sort by Location, which intentionally has no preset here.
export const SORT_OPTIONS = [
  { key: 'score', dir: 'desc', label: 'Best score' },
  { key: 'score', dir: 'asc', label: 'Lowest score' },
  { key: 'title', dir: 'asc', label: 'Title A–Z' },
  { key: 'company', dir: 'asc', label: 'Company A–Z' },
  { key: 'added', dir: 'desc', label: 'Newest first' },
  { key: 'added', dir: 'asc', label: 'Oldest first' },
];

// Comparator for the Available table. The primary key is operator-chosen; ties
// always fall back to score-desc so the order is stable + sensible.
export function compareRecs(a, b, key, dir) {
  const mul = dir === 'asc' ? 1 : -1;
  let primary;
  switch (key) {
    case 'title':
      primary = (a.job?.title ?? '').localeCompare(b.job?.title ?? '');
      break;
    case 'company':
      primary = (a.job?.company ?? '').localeCompare(b.job?.company ?? '');
      break;
    case 'location': {
      const la = [a.job?.location?.country, a.job?.location?.city].filter(Boolean).join(' ');
      const lb = [b.job?.location?.country, b.job?.location?.city].filter(Boolean).join(' ');
      primary = la.localeCompare(lb);
      break;
    }
    case 'added':
      primary = new Date(a.createdAt ?? 0) - new Date(b.createdAt ?? 0);
      break;
    case 'score':
    default:
      primary = (a.scoreTotal ?? 0) - (b.scoreTotal ?? 0);
      break;
  }
  primary *= mul;
  if (primary !== 0) return primary;
  return (b.scoreTotal ?? 0) - (a.scoreTotal ?? 0); // stable tiebreak by score-desc
}
